import type { RequestFn } from '../http';
import type { PortalAreaValue } from '../../portalAccessTypes';

/** Kundenportal-SSO Zugangsanfrage (Phase 2 REQUEST) */
export interface PortalAccessRequest {
  id: string;
  provider: 'MICROSOFT' | 'GOOGLE';
  email: string;
  name: string | null;
  org: string | null;
  emailDomain: string;
  customer: { id: string; name: string } | null;
  /** Bereiche, die der zugeordnete Kunde freigibt — null ohne Zuordnung */
  companyModules: string[] | null;
  status: 'PENDING' | 'APPROVED' | 'REJECTED';
  /** Selbstauskunft der Person (Login-Seite): Firmenname */
  companyNameInput: string | null;
  /** Selbstauskunft der Person (Login-Seite): eigener Name */
  personNameInput: string | null;
  attemptCount: number;
  lastAttemptAt: string;
  createdAt: string;
  decidedAt: string | null;
  grantedRole: string | null;
  /** Darf der aktuelle Nutzer diese Anfrage (mit der Auswahl einer Standard-Rolle) entscheiden? */
  canDecide: boolean;
  /** Darf der aktuelle Nutzer Portal-Admins und privilegierte Bereiche vergeben / Kunden zuordnen? (Teamlead+) */
  canElevate: boolean;
}

export function createPortalAccessRequestsApi(request: RequestFn) {
  return {
    async getPortalAccessRequests(status: 'PENDING' | 'ALL' = 'PENDING') {
      return request<PortalAccessRequest[]>(`/portal-access-requests?status=${status}`);
    },

    /** Kunden-Suche für die manuelle Zuordnung — mit den Bereichen, die der Kunde freigibt. */
    async searchPortalAccessCustomers(q: string) {
      return request<Array<{ id: string; name: string; enabledModules: string[] }>>(
        `/portal-access-requests/customers?q=${encodeURIComponent(q)}`
      );
    },

    async approvePortalAccessRequest(id: string, data: PortalAreaValue & { customerId?: string }) {
      return request<{ ok: boolean; contactId: string; existingAccess: boolean }>(
        `/portal-access-requests/${id}/approve`,
        {
          method: 'POST',
          body: JSON.stringify(data),
        }
      );
    },

    async rejectPortalAccessRequest(id: string) {
      return request<{ ok: boolean }>(`/portal-access-requests/${id}/reject`, {
        method: 'POST',
        body: JSON.stringify({}),
      });
    },
  };
}
